import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Auth is carried by an httpOnly "access_token" cookie set by the backend.
// withCredentials ensures the cookie is sent with API requests. No token is
// stored in JS/localStorage, which removes the XSS token-theft vector.
const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export default api;
